export const ENTER_ORDER_DETAILS='ENTER_ORDER_DETAILS'
export const ENTER_BILLING_DETAILS='ENTER_BILLING_DETAILS'
export const GET_YOUR_ORDERS='GET_YOUR_ORDERS'
export const OPTIONS='OPTIONS'
export const EMPTY_ORDER='EMPTY_ORDER'
export const START_LOADING_ORDERS='START_LOADING_ORDERS'
export const END_LOADING_ORDERS='END_LOADING_ORDERS'